import jsTracking from 'lib/jsTracking'

// Types
import { APIAction, Dispatch, GetState } from 'types'

export const actions = {
  trackevent:
    (name: string, properties?: Record<string, unknown>, external = true) =>
    (dispatch: Dispatch, getState: GetState) => {
      if (external) {
        jsTracking(name, properties)
      }

      const { isAuthenticated } = getState().auth
      if (!isAuthenticated) {
        return Promise.resolve()
      }
      return dispatch(
        actions.trackEventCall(name, {
          ...properties,
          url: window.location.href,
        }),
      )
    },

  trackPlayTrack: (trackId: number, contextKey: string, url: string) => ({
    CALL_API: {
      type: 'SONG_TRACK',
      method: 'POST',
      endpoint: '/api/song/play/',
      data: { track_id: trackId, played_from: contextKey, url },
    },
  }),

  trackEventCall: (name: string, properties: Record<string, unknown>) => ({
    CALL_API: {
      type: 'TRACK_EVENT',
      method: 'POST',
      endpoint: '/api/syntheia/trackevent/',
      data: {
        name,
        props: properties,
      },
    },
  }),

  peopleSet: (properties: Record<string, unknown>): APIAction => ({
    CALL_API: {
      type: 'PEOPLE_SET',
      method: 'POST',
      endpoint: '/api/syntheia/peopleset/',
      data: {
        props: properties,
      },
    },
  }),

  peopleSetOnce: (properties: Record<string, unknown>): APIAction => ({
    CALL_API: {
      type: 'PEOPLE_SET_ONCE',
      method: 'POST',
      endpoint: '/api/syntheia/peoplesetonce/',
      data: {
        props: properties,
      },
    },
  }),
}
